import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "material-ui/styles";
import Typography from "material-ui/Typography";
import DialogModal from "../../common/DialogModal";
import Button from "../../Parts/Button";
import * as messages from "../../../constants/Messages";
import NotificationBar from "../../Parts/NotificationBar.jsx";
import { addCommas } from "../../../utils/utils";
import AutoComplete from "../../common/AutoComplete";
import Chip from "material-ui/Chip";
import CancelCircle from "../../Icons/CancelCircle";
import Loader from "../../Parts/Loader";
import { TagType } from "../../../constants/ComponentTypes";
const { Set } = require("immutable");

const styles = () => ({
  paper: {
    maxHeight: "unset",
    background: "#F4F6F9",
    width: "600px",
  },

  contentContainer: {
    padding: "25px",
    margin: 0,
  },

  deleteContentContainer: {
    padding: "50px 50px",
    margin: 0,
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    width: "450px",
    boxSizing: "border-box",
    background: "#FFFFFF",
    textAlign: "left",
  },

  emptyContainer: {
    padding: "50px",
    position: "relative",
    background: "#FFFFFF",
    border: "1px solid #D8DBDF",
    boxSizing: "border-box",
    width: "100%",
  },

  container: {
    background: "#FFFFFF",
    border: "1px solid #D8DBDF",
    width: "100%",
    boxSizing: "border-box",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },

  row: {
    padding: "15px",
    width: "100%",
    display: "flex",
    alignItems: "center",
    flexDirection: "row",
    justifyContent: "center",
    boxSizing: "border-box",
  },

  buttonContainer: {
    display: "inline-flex",
    width: "100%",
    justifyContent: "space-evenly",
    marginTop: "40px",
  },

  title: {
    textAlign: "left",
    fontWeight: "bold",
    fontSize: "13px",
    color: "#71737B",
    marginBottom: "10px",
  },

  caution: {
    height: '15px',
    width: '15px',
    borderRadius: '50%',
    lineHeight: '15px',
    textAlign: 'center',
    background: '#71737A',
    color: '#FFFFFF',
    display: 'inline-block',
    marginRight: '5px',
    fontSize: '9px',
    verticalAlign: 'middle'
  },

  flex: {
    flex: 1,
  },

  chipContainer: {
    width: "100%",
  },

  chipRoot: {
    margin: "0 10px 5px 0",
    float: "left",
    backgroundColor: "rgba(26,101,255,.05)",
    border: "#1A65FF solid 1px",
    color: "#181819",
    height: "27px",
    borderRadius: "2px",
  },

  chipLabel: {
    padding: "5px 17px 5px 10px",
    fontSize: "11px",
  },
});

class EditTagsDialog extends React.Component {
  state = {
    tags: Set(),
    tag: "",
    errors: {},
    showDeleteDialog: false,
    showNotification: false,
    message: "",
    messageType: "success",
  };

  componentWillMount() {
    // Only fetch tags when the delete section is shown (normal AddressBook flow).
    // When opened from recommend/chat flow we hide the delete section and don't need to fetch tags immediately.
    if (!this.props.hideDeleteSection && typeof this.props.getTags === 'function') {
      this.props.getTags(this.props.query, false, true);
    }
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.isDeletingAddressTags && !nextProps.isDeletingAddressTags) {
      this.displayNotification(messages.DELETE_TAG_SUCCESS, "green");
      this.props.getTags(this.props.query, false, false);
    }

    if (!this.props.isDeletingAddressTags && nextProps.isDeletingAddressTags) {
      this.displayNotification(messages.DELETING_TAG, "success");
    }
  }

  handleChipsDelete = (tag) => {
    this.setState({
      tags: this.state.tags.delete(tag),
    });
  };

  handleAddTag = (tag) => {
    this.setState({
      tags: this.state.tags.add(tag),
    });
  };

  handleDelete = () => {
    this.setState({
      showDeleteDialog: false,
    });

    this.props.deleteTag({
      tag_name: this.state.tag,
      type: TagType.CUSTOM_TAG,
      ...this.props.query,
    });
    this.props.toggleDialog();
  };

  handleSave = () => {
    this.props.toggleDialog();
    this.props.saveTags(this.state.tags.toArray());
  };

  handleClick = () => {
    this.props.toggleDialog();
    // If this dialog was opened from recommend/chat flow, pass query to CreateListDialog
    if (this.props.fromRecommend) {
      this.props.toggleCreateListDialog(this.props.item, this.props.query);
    } else {
      this.props.toggleCreateListDialog(this.props.item);
    }
  };

  toggleDeleteDialog = (tag) => () => {
    this.setState({
      tag: tag,
      showDeleteDialog: !this.state.showDeleteDialog,
    });
  };

  displayNotification = (message, type) => {
    this.setState({
      showNotification: true,
      message: message,
      messageType: type,
    });
  };

  displayDialogText = () => {
    let dialogText = 'アドレス';
    // キーマンデータベースの場合は文言の表示を「キーマン」に変更する
    if (document.URL.match("/executive-list")) {
      dialogText = 'キーマン';
    }
    return dialogText;
  };

  renderNotification = () => {
    return (
      <div
        style={{
          position: "fixed",
          zIndex: 10000,
          top: 10,
          left: "calc(50% - 100px)",
        }}
      >
        <NotificationBar
          message={this.state.message}
          type={this.state.messageType}
          open={this.state.showNotification}
          onHandleClose={() => {
            this.setState({ showNotification: false });
          }}
          autoClose={true}
          animation="fade"
        ></NotificationBar>
      </div>
    );
  };

  renderRow = (tag, index, isLast = false) => {
    const { classes } = this.props;

    return (
      <div
        className={classes.row}
        key={index}
        style={{ borderBottom: isLast ? "none" : "1px solid #D8DBDF" }}
      >
        <Typography variant="subheading">{tag}</Typography>

        <div className={classes.flex}></div>

        <Button
          type="ghost"
          text="除外"
          handleClickButton={this.toggleDeleteDialog(tag)}
          style={{ width: "70px", minWidth: "unset", padding: "0px" }}
        ></Button>
      </div>
    );
  };

  renderDeleteDialog = () => {
    const { classes } = this.props;
    const dialogText = this.displayDialogText();

    return (
      <DialogModal
        open={this.state.showDeleteDialog}
        onClose={this.props.toggleDialog}
        aria-labelledby="pop-up-window"
        maxWidth={false}
        classes={{
          contentContainer: classes.deleteContentContainer,
        }}
      >
        <Typography variant="subheading" className={classes.text} style={{ fontWeight: 'bold' }}>
          リスト「{this.state.tag}
          」から選択した{dialogText}を除外します。よろしいですか？
        </Typography>

        <Typography variant="body2" className={classes.text} style={{ marginTop: '25px', fontSize: '15px' }}>
          <span className={classes.caution}>！</span>空になったリストは自動的に削除されます。
        </Typography>
        <div className={classes.buttonContainer}>
          <Button
            handleClickButton={this.toggleDeleteDialog("")}
            text="キャンセル"
            type="ghost"
          ></Button>
          <Button
            handleClickButton={this.handleDelete}
            text="削除"
            loading={this.props.isDeletingAddressTags}
          ></Button>
        </div>
      </DialogModal>
    );
  };

  renderChips = () => {
    const { classes } = this.props;
    return this.state.tags.toArray().map((tag, i) => {
      return (
        <Chip
          key={i}
          label={tag}
          color="primary"
          classes={{
            root: classes.chipRoot,
            label: classes.chipLabel,
          }}
          onDelete={() => this.handleChipsDelete(tag)}
          deleteIcon={<CancelCircle width={15} height={15} color="#6F9EFF" />}
        />
      );
    });
  };

  render() {
    const { classes, toggleDialog, isOpen, selectCount } = this.props;
    const dialogText = this.displayDialogText();
    let notification = this.renderNotification();

    if (this.state.showDeleteDialog) {
      return this.renderDeleteDialog();
    } else {
      return (
        <DialogModal
          title={`選択した${dialogText}をリストに追加 / 削除`}
          open={isOpen}
          onClose={toggleDialog}
          aria-labelledby="pop-up-window"
          maxWidth={false}
          classes={{
            paper: classes.paper,
            contentContainer: classes.contentContainer,
          }}
        >
          <NotificationBar
            message={`${addCommas(selectCount)}件の${dialogText}を選択中`}
            type="ghost"
            open={true}
            autoClose={false}
            disableOnclickListener={true}
            style={{
              transform: "none",
              boxShadow: "none",
              width: "100%",
              boxSizing: "border-box",
              marginBottom: "20px",
            }}
            animation="none"
          ></NotificationBar>
          <div className={classes.title}>リストに追加</div>
          <div className={classes.container} style={{ marginBottom: "20px" }}>
            <div className={classes.row}>
              <AutoComplete
                id="executive-list-autocomplete"
                options={this.props.options}
                onItemSelected={this.handleAddTag}
                placeholder="リストを選択してください"
                InputProps={{
                  readOnly: true,
                }}
              />
            </div>
            {this.state.tags.count() > 0 && (
              <div
                className={classes.row}
                style={{ padding: "0px 15px 10px 15px" }}
              >
                <div className={classes.chipContainer}>
                  {this.renderChips()}
                </div>
              </div>
            )}
            <div
              className={classes.row}
              style={{ padding: "0", justifyContent: "flex-start" }}
            >
              <Button
                text="新規リストを作成"
                type="ghost"
                size="extra-small"
                handleClickButton={this.handleClick}
                style={{
                  color: '#2E68F6',
                  border: 'none',
                  fontSize: '13px'
                }}
              />
            </div>
            <div
              className={classes.row}
              style={{ padding: "15px" }}
            >
              <Button
                handleClickButton={this.handleSave}
                text="選択したリストに追加"
                loading={this.props.isUpdatingTags}
                disabled={this.state.tags.count() === 0}
                style={{
                  width: "100%",
                  minWidth: "unset",
                  padding: "0px",
                }}
              ></Button>
            </div>
          </div>

          <div className={classes.title}>リストから削除</div>
          {(() => {
                const tags = this.props.tags || [];
                if (
                  this.props.isLoadingSelectedAddressTags &&
                  tags.length === 0
                ) {
              return (
                <div className={classes.emptyContainer}>
                  <Loader type="color" size="large" />
                </div>
              );
                } else if (tags.length === 0) {
              return (
                <div className={classes.emptyContainer}>
                  <Typography variant="body2" style={{ color: "#71737B" }}>
                    リストはありません。
                  </Typography>
                </div>
              );
            } else {
              return (
                <div className={classes.container}>
                      {Object.values(tags).map((tag, i) =>
                        this.renderRow(tag, i, i === tags.length - 1)
                      )}
                </div>
              );
            }
          })()}
          {notification}
        </DialogModal>
      );
    }
  }
}

EditTagsDialog.propTypes = {
  classes: PropTypes.object.isRequired,
  isOpen: PropTypes.bool.isRequired,
  toggleDialog: PropTypes.func.isRequired,
  tags: PropTypes.array,
  deleteTag: PropTypes.func.isRequired,
  getTags: PropTypes.func.isRequired,
  saveTags: PropTypes.func.isRequired,
  isDeletingAddressTags: PropTypes.bool,
  isLoadingSelectedAddressTags: PropTypes.bool,
  isUpdatingTags: PropTypes.bool,
  errorMessage: PropTypes.string,
  selectCount: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  toggleCreateListDialog: PropTypes.func.isRequired,
  options: PropTypes.array,
  query: PropTypes.object,
  hideDeleteSection: PropTypes.bool,
  fromRecommend: PropTypes.bool,
  item: PropTypes.object,
};

export default withStyles(styles)(EditTagsDialog);



// WEBPACK FOOTER //
// ./src/components/AddressBook/dialogs/EditTagsDialog.jsx